import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

import { Icon } from "@iconify/react";
import { useDispatch, useSelector } from "react-redux";
import { fetchGeneralpage, fetchServicepage } from "../Redux/slice/homeSlice";

const NavRap = styled.div`
  background: #ffffff;
  background-position: top;
  position: sticky;
  top: 0px;
  z-index: 9999;
  height: 72px;
  .nav-link {
    text-decoration: none;
    color: #121212;

    font-size: 16px;
    font-weight: 600;
  }
  .btn-link {
border: 1px solid #E77817;
font-size: 16px;
    font-weight: 600;
    border-radius: 100px;
    width: 128px;
    height: 44px;
    display: flex;
        text-decoration: none;

    align-items: center;
    justify-content: center;
    color: #E77817;
  }
   .btn-link.active {
    background: #E77817;
    color: #ffffff;
   }
   .btn-link:hover {
     background: #E77817;
    color: #ffffff;
   }
  nav img {
    width: 54px;
    height: 32px;
  }
  .nav-link.active {
    color: #8f8d8c;
  }
  .navbar {
    display: flex;
    align-items: center;
    gap: 20px;
  }
  .nav-mobile {
    display: none;
  }
  nav {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 60px;
  }
  .contact-us {
    box-shadow: 0px 5px 20px 0px #0000001a;
    background: #34302f;
    width: 128px;
    height: 40px;
    border-radius: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ffffff;
    font-size: 13px;
    font-weight: 600;
    text-decoration: none;
  }
  .contact-search {
    display: flex;
    align-items: center;
    gap: 15px;
  }
.nav-item {
  position: relative;
}

.service-dropdown {
  background: #ffffff;
  border: 1px solid #34302f1a;
  width: 294px;
  border-radius: 10px;
  display: none;
  flex-direction: column;
  position: absolute;
  top: 20px;
  z-index: 100;
}

.nav-item:hover .service-dropdown {
  display: flex;
}

  .service-links {
    padding: 10px 15px;
    color: #34302f;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
  }
  .service-links:hover {
    background: #f7f7f7;
  }
  @media (max-width: 678px) {
    .navbar {
      display: flex;
      flex-direction: column;
      align-items: flex-start !important;
      justify-content: flex-start !important;
      position: fixed;
      top: 70px;
      left: -360px;
      width: 300px;
      height: 100vh;
      background: #ffffff;
      color: #34302f;
      box-shadow: 0 40px 60px rgba(0, 0, 0, 0.1);
      padding: 40px 0 0 30px;
      transition: 0.3s ease-in-out;
      z-index: 9999;
    }

    .navbar.active {
      left: 0px;
    }
    .nav-mobile {
      display: block;
    }
    .nav-upper {
      padding: 8px 30px;
    }
    .nav-lower {
      padding: 0px 30px;
    }
    nav {
      padding: 10px 20px !important;
    }
  }
  @media (max-width: 550px) {
  }
`;

const Nav = () => {
  const dispatch = useDispatch();

  const { generalObject, serviceObject, homeObject, loading, error } =
    useSelector((state) => state.content || []);

  console.log(serviceObject);

    const handleScroll = (id) => {
   
  };

  const [clicked, setClicked] = useState(false);
  const [activeLink, setActiveLink] = useState("home");
  const [serviseShow, setServiceShow] = useState(false);
  const websetting = generalObject?.data?.websetting;

  const handleClick = () => {
    setClicked(prev => !prev); // Toggle open/close
  };

  useEffect(() => {
    dispatch(fetchGeneralpage()); // Call API on component mount
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchServicepage()); // Call API on component mount
  }, [dispatch]);

  const handleLinkClick = (link) => {
    setActiveLink(link);
     const section = document.getElementById(link);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      console.log(link);
      
    }
    setClicked(prev => !prev);
  };

  const { pathname } = useLocation();
  useEffect(() => {
    setClicked(false); // Close menu when route changes
  }, [pathname]);

  const showServiceLinks = () => {
    setServiceShow(!serviseShow);
    setActiveLink("services");
  };
  return (
    <NavRap>
      <nav>
        <div className="nav-mobile" onClick={handleClick}>
          {clicked ? (
            <Icon
              width="30px"
              height="30px"
              icon="prime:times"
              style={{ color: "#34302F" }}
            />
          ) : (
            <Icon
              width="30px"
              height="30px"
              icon="mdi-light:menu"
              style={{ color: "#34302F" }}
            />
          )}
        </div>
        <img
          src={`https://admin.abrigo-llc.com/${websetting?.favicon_url}`}
          alt=""
        />

        <div className={clicked ? "navbar active" : "navbar"} id="#navbar">
          <Link 
            className={`nav-link ${activeLink === "home" ? "active" : ""}`}
            to="/"
            onClick={() => handleLinkClick("home")}
          >
            Home
          </Link>
          {/* <Link
            className={`nav-link ${activeLink === "about" ? "active" : ""}`}
            onClick={() => handleLinkClick("about")}
          >
            About Us
          </Link> */}
<div
  className="nav-item"
  style={{ position: "relative" }}
  onMouseEnter={() => setServiceShow(true)}
  onMouseLeave={() => setServiceShow(false)}
>
  <Link
    className={`nav-link ${activeLink === "services" ? "active" : ""}`}
    onClick={() => handleLinkClick("services")}
  >
    What we do
  </Link>
<div>
  
  </div>
</div>


          <Link
            className={`nav-link company ${
              activeLink === "company" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("company")}
          >
            Projects
          </Link>
          <Link
            className={`btn-link ${activeLink === "contact" ? "active" : ""}`}
            onClick={() => handleLinkClick("contact")}
          >
            Get in touch
          </Link>
           {/* <Link
            className={`nav-link ${activeLink === "about" ? "active" : ""}`}
            to="/test"
            onClick={() => handleLinkClick("about")}
          >
            Test
          </Link> */}
        </div>
        
      </nav>
    </NavRap>
  );
};

export default Nav;
